console.log("==== Global Rules Loaded ==== ");
const verifyDeliveryArea = () => {};
const verifyMenuChanged = async () => {
  try {
    const menuWeekSection = (await fetchSection("current-menu-week")) || null;
    if (menuWeekSection == null) {
      return;
    }
    const fetchedMenuWeek = parseInt(menuWeekSection?.innerHTML);
    const browserWeekMenu = window.current_week_menu;
    const cart = await fetchCart();
    const productsNotAvailable = [];
    if (cart.items.length > 0) {
      for (const line_item of cart.items) {
        const product_data = await fetchProductJSON(line_item.handle);
        if (product_data.error) productsNotAvailable.push(line_item);
      }
    }
    if (
      productsNotAvailable.length > 0 ||
      fetchedMenuWeek !== browserWeekMenu
    ) {
      createModal({
        title: `<i class="fa-solid fa-arrows-rotate"></i> ROTATING MENU`,
        content: `
            <p>Your session has expired and there is a new menu for the week. The items you had selected are no longer available and have been removed from your cart. Please select new items.</p>
              <p class="info"><i class="fa-solid fa-circle-info"></i>New menu every Monday at 10am</p>`,
        confirmButton: {
          text: "OK, I WILL SELECT AGAIN",
          action: async () => {
            await fullClearCart();
            localStorage.clear();
            sessionStorage.clear();
            location.href = location.pathname;
          },
        },
      });
    }
  } catch (e) {
    console.error(e);
  }
};

// RULES TRIGGERS
document.addEventListener("visibilitychange", async (event) => {
  if (document.visibilityState == "visible") {
    await verifyMenuChanged();
  }
});
